window.USER_MANAGER_TYPE_ID = 1;

window.stringToUCWords = function (value) {
  if (!value) return '';
  let splitStr = value.replace(/-/g, "_").split('_');
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
};

window.capitalize = function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1)
};

window.numberFormat = function (value, decimals) {
  if (!value) return 0;
  value = parseFloat(value);
  if (!isFinite(value) || (!value && value !== 0)) return '';
  decimals = decimals != null ? decimals : 2;
  let stringified = Math.abs(value).toFixed(decimals);
  let _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified;
  let i = _int.length % 3;
  let head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : '';
  let _float = decimals
    ? stringified.slice(-1 - decimals)
    : '';
  let sign = value < 0 ? '-' : ''
  return sign + head +
    _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') +
    _float;
};

window.roundNumber = function (value, decimals) {
  if (!value) return 0;
  value = parseFloat(value);
  if (typeof decimals == 'undefined')
    decimals = 0;
  var m = 1;
  switch (decimals) {
    case 0:
      m = 1;
      break;
    case 1:
      m = 10;
      break;
    case 2:
      m = 100;
      break;
    case 3:
      m = 1000;
      break;
    case 4:
      m = 10000;
      break;
    default:
      m = Math.pow(10, decimals);
      break;
  }
  return Math.round(value * m + Number.EPSILON) / m;
};

window.moneyFormat = function (value, decimals) {
  if (!value) return '$0';
  value = parseFloat(value);
  if (!isFinite(value) || (!value && value !== 0)) return '';
  decimals = decimals != null ? decimals : 2;
  let stringified = Math.abs(value).toFixed(decimals);
  let _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified;
  let i = _int.length % 3;
  let head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : '';
  let _float = decimals
    ? stringified.slice(-1 - decimals)
    : '';
  let sign = value < 0 ? '-$' : '$'
  return sign + head +
    _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') +
    _float;
};

window.notEmpty = function (val) {
  return typeof val != 'undefined' && val != null;
};

window.getValue = function (obj, field, def_val) {
  if(typeof def_val == 'undefined')
    def_val = null;
  return this.notEmpty(obj[field])?obj[field]: def_val;
};

window.getOptionsFromArrayObject = function ( items, id_field, text_field ) {
  let options = [];
  for(let i in items){
    let id_val = this.getValue(items[i], id_field);
    let text_val = this.getValue(items[i], text_field);
    if(id_val == null || text_val == null)
      continue;
    options.push({id: id_val, text: text_val});
  }
  return options;
};

window.getObjectByKeyValue = function ( items, key, value ) {
  for(let i in items){
    let val = this.getValue(items[i], key);
    if(val == null)
      continue;
    if(val == value)
      return items[i];
  }
  return null;
};

window.generateObjectsWithKeyFromArray = function ( items, key ) {
  let list = {};
  for(let i in items){
    let id_val = this.getValue(items[i], key);
    if(id_val == null)
      continue;
    list[id_val] = items[i];
  }
  return list;
};

window.getArrayValuesFromObjects = function ( items, key ) {
  let arr = [];
  for(let i in items){
    let val = this.getValue(items[i], key);
    if(val == null)
      continue;
    arr.push(val);
  }
  return arr;
};

window.numkeys = function(object) {
  if (typeof object == 'undefined' || object == null || !object)
    return 0;
  return Object.keys(object).length;
};

window.nl2br = function(value) {
  return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
};

window.downloadFromBlob = function(data, filename) {
  let url = window.URL.createObjectURL(new Blob([data]));
  let link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
